<script>
import IconChevronDown from "@js/components/Icons/IconChevronDown.vue";
import {Link} from "@inertiajs/vue3";

export default {
    name: "MobileMenuDropdownBlock",
    components: {Link, IconChevronDown},
    props: {
        btnText: {
            required: true,
        },
        route_name: {
            default: null,
        },
        route_params: {
            type: Object,
            default: () => ({}),
        },
        icon_path: {
            default: null,
        },
        items: {
            type: Array,
            default: () => [],
        },
        forceOpen: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isOpen: this.forceOpen,
        };
    },
    methods: {
        toggleOpen() {
            this.isOpen = !this.isOpen;
        },

        hasLink(item) {
            return !!(item?.url || item?.route_name);
        },

        buildOwnLink() {
            if (this.route_params?.url) {
                return this.route_params.url;
            }

            if (!this.route_name) {
                return null;
            }

            const fullParams = this.route_params ?? {};
            const {query, ...pureRouteParams} = fullParams;

            let url = route(this.route_name, pureRouteParams);

            if (query && typeof query === 'object') {
                const queryParams = new URLSearchParams();

                for (const [key, values] of Object.entries(query)) {
                    queryParams.append(key, JSON.stringify(values));
                }

                const queryString = queryParams.toString();

                if (queryString) {
                    url += `?${queryString}`;
                }
            }

            return url;
        },

        buildMenuLink(item) {
            if (item?.url) {
                return item.url;
            }

            if (!item?.route_name) {
                return null;
            }

            const fullParams = item.route_params ?? {};
            const {query, ...pureRouteParams} = fullParams;

            let url = route(item.route_name, pureRouteParams);

            if (query && typeof query === 'object') {
                const queryParams = new URLSearchParams();

                for (const [key, values] of Object.entries(query)) {
                    queryParams.append(key, JSON.stringify(values));
                }

                const queryString = queryParams.toString();

                if (queryString) {
                    url += `?${queryString}`;
                }
            }

            return url;
        },
    },
};
</script>

<template>
    <div>
        <div class="grid w-full grid-cols-12 rounded-lg p-2 ps-0 text-base text-gray-900 transition duration-75 group">
            <template v-if="route_name">
                <Link
                    class="col-span-8 flex items-center gap-3 text-left font-medium"
                    :href="buildOwnLink()"
                >
                    <div
                        v-if="icon_path"
                        class="h-[40px] w-[40px] min-h-[40px] min-w-[40px]"
                    >
                        <img
                            alt=""
                            aria-hidden="true"
                            role="presentation"
                            :src="icon_path"
                            class="h-full w-full object-cover"
                        />
                    </div>

                    {{ btnText }}
                </Link>
            </template>

            <template v-else>
                <div
                    class="col-span-8 flex items-center gap-3 text-left font-medium"
                    @click.prevent="toggleOpen"
                >
                    <div
                        v-if="icon_path"
                        class="h-[40px] w-[40px] min-h-[40px] min-w-[40px]"
                    >
                        <img
                            alt=""
                            aria-hidden="true"
                            role="presentation"
                            :src="icon_path"
                            class="h-full w-full object-cover"
                        />
                    </div>

                    {{ btnText }}
                </div>
            </template>

            <div
                class="col-span-4 flex items-center justify-end"
                @click.prevent="toggleOpen"
            >
                <IconChevronDown :rotate="isOpen" class="menu-chevron h-5 w-5 transition-transform"/>
            </div>
        </div>

        <ul v-if="isOpen" class="space-y-2 divide-y">
            <li
                v-for="(item, index) in items"
                :key="index"
                class="ms-5 pt-2"
            >
                <div v-if="item.sub_menu && item.sub_menu.length">
                    <MobileMenuDropdownBlock
                        :btnText="item.title"
                        :items="item.sub_menu"
                        :route_name="item.route_name"
                        :route_params="item.route_params"
                        :icon_path="item.icon ?? null"
                    />
                </div>

                <div v-else>
                    <component
                        :is="hasLink(item) ? 'Link' : 'div'"
                        :href="hasLink(item) ? buildMenuLink(item) : undefined"
                        class="flex w-full items-center rounded-lg p-2 ps-0 text-base font-medium text-gray-900 transition duration-75 group"
                    >
                        {{ item.title }}
                    </component>
                </div>
            </li>
        </ul>
    </div>
</template>

<style scoped lang="scss">
</style>
